import './mapscrolly.css';

import { scaleLinear } from 'd3-scale';
// import lineSliceAlong from '@turf/line-slice-along';
// import length from '@turf/length';

let DEBUG = true;

let mapboxgl;
let map;
let mapContainer;
let mapOverlay;
let mapLoaded;
let zoom; // initial zoom
let currentZoom;
let currentPos;
let forceUpdate = false;
let initial = true;
let terrain;
let exaggeration;
let currentExaggeration;

function getStr(s) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

let orientation = 'landscape'; // or 'portrait';
let orientationStr = getStr(orientation);
let size = 'large'; // or 'small'
let padding;
let pad;
let callback;



const BUFFER = 32;
const TOLERANCE = 1.3;


function updatePadding() {
  if (map) {

    if (orientation === 'landscape' && size === 'large') {
      pad = 400;
      padding = 'left';
    }
    if (orientation === 'landscape' && size === 'small') {
      pad = 180;
      padding = 'left';
    }
    if (orientation === 'portrait' && size === 'large') {
      pad = 40;
      padding = 'bottom';
    }
    if (orientation === 'portrait' && size === 'small') {
      pad = 20;
      padding = 'bottom';
    }

    const p = { left: 0, bottom: 0};
    p[padding] = pad;
    //map.jumpTo({padding: p});
  }

}

function updateSize() {
  mapContainer.classList.toggle('portrait', orientation === 'portrait');
  mapContainer.classList.toggle('landscape', orientation === 'landscape');
  mapContainer.classList.toggle('large', size === 'large');
  mapContainer.classList.toggle('small', size === 'small');
  config.screen = orientation === 'landscape' ? (size === 'small' ? config.screenPortraitSmall : config.screenPortraitLarge) : (size === 'small' ? config.screenPortraitSmall : config.screenPortraitLarge);
  updatePadding();

  callback(orientation, size, config.screen);
}

function setupResize() {
  const mqOrientation = window.matchMedia("(orientation: portrait)");
	const mqOrientationListener = (v) => {
    orientation = v.matches ? 'portrait' : 'landscape';
    orientationStr = getStr(orientation);

    updateSize();
  };
	mqOrientation.addEventListener ? mqOrientation.addEventListener("change", mqOrientationListener) : mqOrientationListener.addListener(mqOrientationListener);
	orientation = mqOrientation.matches ? 'portrait' : 'landscape';
  orientationStr = getStr(orientation);


	const mqSize = window.matchMedia("(orientation: portrait) and (max-width: 480px), (orientation: landscape) and (max-height: 480px)");
	const mqSizeListener = (v) => {
    size = v.matches ? 'small' : 'large';
    updateSize();
  };
	mqSize.addEventListener ? mqSize.addEventListener("change", mqSizeListener) : mqSizeListener.addListener(mqSizeListener);
	size = mqSize.matches ? 'small' : 'large';

  updateSize();
}

const nothing = {
  'type': 'FeatureCollection',
  'features': []
};


let mapRenderFct;
let mapRunning = true;

function stopMap() {
  mapRunning = false;
  mapRenderFct = map._render;
  map._render = () => {};
}

function startMap() {
  mapRunning = true;
  map._render = mapRenderFct; 
  map.triggerRepaint();
}



//
// const loadDataPromises = {};

let loadDataPromise = null;

function loadData(src) {
  if (!loadDataPromise) loadDataPromise = fetch(PATH + 'data/all.geo.json').then(r => r.json());

  return loadDataPromise.then(r => r[src]);
}


function copy(x) {
  return JSON.parse(JSON.stringify(x));
}

function getArrayDepth(value) {
  return Array.isArray(value) ?
    1 + Math.max(0, ...value.map(getArrayDepth)) :
    0;
}

function moreThanLineStrings(features) {
  let out = false;
  features.forEach((f) => {
    if (getArrayDepth(f.geometry.coordinates) > 2) out = true;
  });
  return out;
}

function toLineStrings(features) {
  const out = [];

  features.forEach((f) => {
    const d = getArrayDepth(f.geometry.coordinates);

    if (d === 2) {
      out.push(f);
    } else if (d === 3) {
      f.geometry.coordinates.forEach((c) => {
        out.push({ type: 'Feature', properties: f.properties, geometry: { type: 'LineString', coordinates: c}});
      });
    } else if (d === 4) {
      f.geometry.coordinates.forEach((c1) => {
        c1.forEach((c) => {
          out.push({ type: 'Feature', properties: f.properties, geometry: { type: 'LineString', coordinates: c}});
        });
      });
    }
  });

  return out;
}

function setLayerSource(layerId, source, sourceLayer) {
    const oldLayers = map.getStyle().layers;
    const layerIndex = oldLayers.findIndex(l => l.id === layerId);
    const layerDef = oldLayers[layerIndex];
    const before = oldLayers[layerIndex + 1] && oldLayers[layerIndex + 1].id;
    layerDef.source = source;
    if (sourceLayer) {
        layerDef['source-layer'] = sourceLayer;
    }
    map.removeLayer(layerId);
    map.addLayer(layerDef, before);
}

const cameraProps = ['lon', 'lat', 'z', 'pitch', 'bearing', 'terrain', 'pad'];

export const config = {
  // history screen: 1000 -> 1500 -> 2500 -> 1700 -> 1900 -> 1700
  // screen: 1900, // size of a "screen" (our unit) in pixels
  screen: 1900, // size of a "screen" (our unit) in pixels
  screenPortraitLarge: 1900,
  screenPortraitSmall: 1700,
  screenLandscapeLarge: 1900,
  screenLandscapeSmall: 1700,
  scrollDelta: 2 * 150 / 2500, // pixels in units of screen
  bounds: [
    [-23.90625, -38.54816542304657],
    [65.0390625, 40.44694705960048],
  ],
  colors: {
    yellow: '#F7CA20',
    highlight: '#F7CA20',
    bg: '#151A27',
  },
  // those are in real screen heights:
  fadeOffsetIn: 0,
  fadeDurationIn: 0.4,
  fadeOffsetOut: 0.3,
  fadeDurationOut: 0.4,
};

function patchVideoSource(s) {
  s.needsUpdate = false;

  s.video.addEventListener('seeked', () => {
    s.needsUpdate = true;
    s.map.triggerRepaint();
  });

  s.hasTransition = function () {
    const result = s.video && (!(s.video.paused || s.video.playbackRate === 0) || s.needsUpdate);
    s.needsUpdate = false;
    return result;
  };

  s.prepare_orig = s.prepare;
  s.prepare = function () {
    if (!s.texture) return s.prepare_orig();
    if (Object.keys(s.tiles).length === 0 || s.video.readyState < 2) {
        return; // not enough data for current position
    }

    const context = s.map.painter.context;
    const gl = context.gl;


    if (!(s.video.paused || s.video.playbackRate === 0) || s.needsUpdate) {
        s.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE);
        gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, s.video);
    }

    s._prepareData(context);
  };

}

function animDraw(d, type, v) {
  if (type !== 'line') console.log('animDraw only lines');
  if (v === 0) {
    map.setPaintProperty(d.idLine, 'line-gradient', [
      'interpolate',
      ['linear'],
      ['line-progress'],
      0, 'transparent',
      1, 'transparent',
    ]);
  } else if (v >= 0.9999) {
    map.setPaintProperty(d.idLine, 'line-gradient', [
      'interpolate',
      ['linear'],
      ['line-progress'],
      0, d.lineColor,
      1, d.lineColor,
    ]);
  } else  {
    map.setPaintProperty(d.idLine, 'line-gradient', [
      'interpolate',
      ['linear'],
      ['line-progress'],
      0, d.lineColor,
      v, d.lineColor,
      v+0.0001, 'transparent',
      1, 'transparent',
    ]);
  }

}

function animFade(d, type, v) {
  // TODO XXXX
  if (type == 'line') map.setPaintProperty(d.idLine, 'line-opacity', v * d.lineOpacity);
  if (type == 'area') map.setPaintProperty(d.idArea, 'fill-opacity', v * d.areaOpacity);
  if (type == 'dot') map.setPaintProperty(d.idDots, 'circle-opacity', v * d.dotOpacity);
  if (type == 'bubble') {
    d.bubbleMarkers.forEach((m) => {
      m.getElement().querySelector('.bubble-dot').style.opacity = v * d.bubbleOpacity;
    });
  }
}

const animationFunctions = {
  'draw': animDraw, // only lines
  'fade': animFade, // everything
};

let oStr;

function loadAllVideos(section) {
  section.videos.forEach((d) => {

    d.scaleSeek = {};
    d.scaleOpacity = {};
    ['landscape', 'portrait'].forEach(o => {
      oStr = getStr(o);

      d.scaleSeek[o] = scaleLinear()
        .domain([d[`timing${oStr}`][1], d[`timing${oStr}`][2]])
        .range([0, 1])
        .clamp(true);
      d.scaleOpacity[o] = scaleLinear()
        .domain(d[`timing${oStr}`])
        .range([0, 1, 1, 0])
        .clamp(true);
    });


    const src = d[`src_${orientation}_${size}`];
    const bbox = d[`bbox_${orientation}`];

    map.addSource(d.id, {
      type: 'video',
      urls: [`${PATH}videos/${src}`],
      coordinates: bbox,
    });


    function checkStop() {
      if (map.getSource(d.id) && map.isSourceLoaded(d.id)) {
        d.source = map.getSource(d.id);
        d.video = d.source.getVideo();
        patchVideoSource(d.source);
        d.video.playbackRate = 0;
        d.video.currentTime = 0;
        d.video.loop = false;
        d.video.preload = "auto";
        d.video.muted = true;
        d.video.play();
        /*
        d.source.video = new Proxy(d.video, {
          get(target, prop) {
            if (prop === 'paused') return false;
            return target[prop];
          }
        });
        */
        d.checkvid =  () => {
          if (d.video.duration && d.t !== undefined) {
            if (d.video.currentTime >= d.t * d.video.duration) {
              d.video.playbackRate = 0;
              d.paused = true;
              //d.video.pause();
              //d.video.pause();
            } else {
              d.video.playbackRate = 1;
              if (d.video.paused) d.video.play();
            }
          }
        };


        map.off('sourcedata', checkStop);
      }
    }
    map.on('sourcedata', checkStop);

    d._visible = false;
    map.addLayer({
      id: d.id,
      type: 'raster',
      source: d.id,
      layout: {
        visibility: 'none'
      },
      paint: {
      },
    }, 'layer-videos');
  });
}


const cameraPositionsToLoad = [];
let tilesLoading = false;

function preloadTiles(section) {
  if (!section.camera) return;
  Object.entries(section.camera).forEach(([k, v]) => {
    v.forEach((c) => {
      if (c.noPreloading) return;
      const pos = c.scroll;
      cameraPositionsToLoad.push({
        center: [section.cameraScales[k].lon(pos), section.cameraScales[k].lat(pos)],
        zoom: zoom + section.cameraScales[k].z(pos),
        pitch: section.cameraScales[k].pitch(pos),
        bearing: section.cameraScales[k].bearing(pos),
        preloadOnly: true,
      });
    });
    
  })
}

function reallyPreloadTiles() {
  tilesLoading = true;

  function next() {
    if (!cameraPositionsToLoad.length) return;
    const c = cameraPositionsToLoad.shift();
    try {
      map.flyTo(c);
    } catch (e) {}
    map.once('idle', next);
  }
  //map.once('idle', next);
  // force first step
  setTimeout(next, 500);
}



const geodataToLoad = [];
let geodataLoading = false;

function reallyLoadGeodata() {
  geodataLoading = true;
  function next() {
    if (!geodataToLoad.length) return;
    const f = geodataToLoad.shift();
    f().then(next);
  }
  next();
}

function loadAllGeodata(section) {
  section.geodata.forEach((d) => {

    geodataToLoad.push(function () {
      let dataLoaded = true;

      d.scale = {};
      ['landscape', 'portrait'].forEach(o => {
        oStr = getStr(o);
        d.scale[o] = scaleLinear()
          .domain(d[`timing${oStr}`])
          .range([0, 0.5, 0.5, 1])
          .clamp(true);
      })

      if (!d.bubbles) {
        if (!map.getSource(d.src)) {
          map.addSource(d.src, {
            type: 'geojson',
            data: nothing,
            lineMetrics: srcNeedsMetrics[d.src] && !srcNeedsExtraLines[d.src],
            buffer: d.dots ? 0 : BUFFER,
            tolerance: TOLERANCE,
          });
          dataLoaded = false;
        }
      }

      if (srcNeedsExtraLines[d.src]) {
        if (!map.getSource(d.src + '-line')) {
          map.addSource(d.src + '-line', {
            type: 'geojson',
            data: nothing,
            lineMetrics: srcNeedsMetrics[d.src],
            buffer: BUFFER,
            tolerance: TOLERANCE,
          });
          dataLoaded = false;
        }
      }

      if (d.area) {
        d.idArea = `${d.id}-area`;
        d.areaColor = d.areaColor || 'pink';
        d.areaOpacity = d.areaOpacity || 1;
        map.addLayer({
          id: d.idArea,
          type: 'fill',
          source: d.src,
          layout: {
            visibility: 'none'
          },
          paint: {
            'fill-color': d.areaColor,
            'fill-opacity': d.areaOpacity,
          },
        }, d.onTop ? 'layer-geo-top' : 'layer-geo');
      }

      if (d.line) {
        d.idLine = `${d.id}-line`;
        d.lineColor = d.lineColor || 'pink';
        d.lineWidth = d.lineWidth || 2;
        d.lineOpacity = d.lineOpacity || 1;
        map.addLayer({
          id: d.idLine,
          type: 'line',
          source: srcNeedsExtraLines[d.src] ? d.src + '-line' : d.src,
          layout: {
            visibility: 'none'
          },
          paint: {
            'line-color': d.lineColor,
            'line-width': d.lineWidth,
            'line-opacity': d.lineOpacity,
          },
        }, d.onTop ? 'layer-geo-top' : 'layer-geo');
      }


      // TODO XXXX
      if (d.bubbles) {
        d.bubbleColor = d.bubbleColor || 'pink';
        d.bubbleOpacity = d.bubbleOpacity || 1;
        d.bubbleScale = d.bubbleScale || 1;
        d.bubbleScaleSmall = d.bubbleScaleSmall || 0.5 * d.bubbleScale;
        d.bubbleValueKey = d.bubbleValueKey || 'value';
        d.bubbleNameKey = d.bubbleNameKey || 'name';
        d.bubbleLabelKey = d.bubbleLabelKey || 'label';
        d.bubbleOrientationKey = d.bubbleOrientationKey || 'orientation';
        d.bubbleShowTextOnSmallScreenKey = d.bubbleShowTextOnSmallScreenKey || 'mobile';
        d.bubbleDelay = d.bubbleDelay || 0;

        dataLoaded = false;

      }

      if (d.dots) {
        d.idDots = `${d.id}-dots`;
        d.dotColor = d.dotColor || 'pink';
        d.dotOpacity = d.dotOpacity || 1;
        d.dotRadius = d.dotRadius || 3;
        map.addLayer({
          id: d.idDots,
          type: 'circle',
          source: d.src,
          layout: {
            // visibility: 'none'
          },
          paint: {
            'circle-color': d.dotColor,
            'circle-opacity': d.dotOpacity,
            'circle-radius': d.dotRadius,
            "circle-radius-transition": {
              duration: 0,
              delay: 0,
            },
            "circle-opacity-transition": {
              duration: 0
            },
          },
        }, d.onTop ? 'layer-geo-top' : 'layer-geo');
      }



      //return loadData(`${PATH}data/${d.src}`).then((r) => {
      return loadData(d.src).then((r) => {
        d.data = r;
        d.data.features = d.data.features.filter(x => x.geometry);

        if (!dataLoaded) {
          if (moreThanLineStrings(d.data.features) && srcNeedsMetrics[d.src]) {
            d.dataLines = { type: 'FeatureCollection', features: toLineStrings(d.data.features) };
            if (srcNeedsExtraLines[d.src]) {
              map.getSource(d.src + '-line').setData(d.dataLines);
              map.getSource(d.src).setData(d.data);
              //if (d.idLine) setLayerSource(d.idLine, d.src + '-line');
            } else {
              map.getSource(d.src).setData(d.dataLines);
              //if (map.getSource(d.src + '-line')) map.removeSource(d.src + '-line');
            }
          } else {
            // TODO XXXX
            if (d.bubbles) {

              d.bubbleMarkers = [];
              const scale = size === 'small' ? d.bubbleScaleSmall : d.bubbleScale;
              d.data.features.forEach((f, i) => {
                const rad = Math.sqrt(f.properties[d.bubbleValueKey]) * scale;
                const delay = i * d.bubbleDelay;
                const el = document.createElement('div');
                el.className = 'bubble';
                el.classList.add('bubble--' + (f.properties[d.bubbleOrientationKey] || 'bottom'));
                const showOnSmall = f.properties[d.bubbleShowTextOnSmallScreenKey] === 'true';
                const name = size === "large" || (size === 'small' && showOnSmall) ? f.properties[d.bubbleNameKey] : '';
                const label = size === "large" || (size === 'small' &&  showOnSmall) ? f.properties[d.bubbleLabelKey] : '';
                el.innerHTML = `
                  <div class="bubble-wrapper" style="width: ${rad/2}px; height: ${rad/2}px;">
                    <div class="bubble-dot" style="width: ${rad/2}px; height: ${rad/2}px; background: ${d.bubbleColor}; animation-delay: ${delay}s;">
                      <div class="bubble-text" style=" animation-delay: ${delay+ 1}s;">
                        <div class="bubble-name">${name || ''}</div>
                        <div class="bubble-label">${label || ''}</div>
                      </div>
                    </div>
                  </div>
                `;
                const marker = new mapboxgl.Marker(el, {anchor: 'center'}).setLngLat(f.geometry.coordinates);
                d.bubbleMarkers.push(marker);
              });
            } else {
              if (d.dots) {
                d._n = d.data.features.length;
                d.data.features.forEach((f, i) => {
                  f.properties._i = i;
                });
              }
              map.getSource(d.src).setData(d.data);
              //if (map.getSource(d.src + '-line')) map.removeSource(d.src + '-line');
            }
          }
        }
        d.loaded = true;
        // d._visible = d.bubbles ? false : true;
        d._visible = false;
        forceUpdate = true;
        delete d.data;
        delete d.dataLines;
      });
    });
  });
  if (!geodataLoading) reallyLoadGeodata();
}

function loadAllImages(section) {
  section.images.forEach((d) => {

    
    d.scale = {};
    ['landscape', 'portrait'].forEach(o => {
      oStr = getStr(o);

      if (d[`timing${oStr}`][0] === d[`timing${oStr}`][1]) d[`timing${oStr}`][0] -= 0.00001;
      if (d[`timing${oStr}`][2] === d[`timing${oStr}`][3]) d[`timing${oStr}`][3] += 0.00001;
      
      d.scale[o] = scaleLinear()
        .domain(d[`timing${oStr}`])
        .range([0, d.maxopacity || 1, d.maxopacity || 1, 0])
        .clamp(true);
    });


    map.addSource(d.id, {
      type: 'image',
      url: `${PATH}mapimages/${d.src}`,
      coordinates: d.bbox,
    });
  
    d._visible = false;

    map.addLayer({
      id: d.id,
      type: 'raster',
      source: d.id,
      layout: {
        visibility: 'none'
      },
      paint: {
        'raster-opacity': 0,
        'raster-fade-duration': 0,
      },
    }, 'layer-images');
  });
}

function loadAllLabels(section) {
  section.labels.forEach((d) => {

    const el = document.createElement('div');
    el.className = 'label';
    el.classList.add('label--' + (d.type || 'simple'));
    if (d.big) el.classList.add('label--big');
    if (d.verybig) el.classList.add('label--verybig');
    if (d.small) el.classList.add('label--small');
    if (d.verysmall) el.classList.add('label--verysmall');
    if (d.highlight) el.classList.add('label--highlight');
    if (d.italic) el.classList.add('label--italic');
    if (d.desktopOnly) el.classList.add('label--desktop-only');
    if (d.mobileOnly) el.classList.add('label--mobile-only');
    const elContent = document.createElement('div');
    elContent.className = 'label-content';
    const elTextWrapper = document.createElement('div');
    elTextWrapper.className = 'label-text-wrapper';
    const elText = document.createElement('div');
    elText.className = 'label-text';
    elText.innerHTML = ''; //d.text;
    if (d.textColor) elText.style.color = d.textColor;
    const elTextBg = document.createElement('div');
    elTextBg.className = 'label-text label-text-bg';
    elTextBg.innerHTML = d.text;
    el.appendChild(elContent);
    elTextWrapper.appendChild(elTextBg);
    elTextWrapper.appendChild(elText);

    const o = d.orientation || 'top';
    // const a = o === 'top' ? 'bottom' : 'top';
    let a;
    if (o === 'top') a = 'bottom';
    if (o === 'bottom') a = 'top';
    if (o === 'left') a = 'right';
    if (o === 'right') a = 'left';

    if (d.type === 'line' && (o === 'bottom' || o === 'right')) {
      const elLine = document.createElement('div');
      elLine.className = 'label-line';
      elLine.classList.add('label--' + o);
      if (o === 'top' || o === 'bottom')
      elLine.style.height = d.line + 'px';
      if (o === 'left' || o === 'right')
      elLine.style.width = d.line + 'px';
      elContent.appendChild(elLine);
      el.classList.add('label--' + o);
      d.typing = !(d.typing === false);
      if (!d.typing) elLine.style.animation = '';
    }
    elContent.appendChild(elTextWrapper);
    if (d.type === 'line' && (o === 'top' || o === 'left')) {
      const elLine = document.createElement('div');
      elLine.className = 'label-line';
      elLine.classList.add('label--' + o);
      if (o === 'top' || o === 'bottom')
      elLine.style.height = d.line + 'px';
      if (o === 'left' || o === 'right')
      elLine.style.width = d.line + 'px';
      elContent.appendChild(elLine);
      el.classList.add('label--' + o);
      d.typing = !(d.typing === false);
      if (!d.typing) elLine.style.animation = 'unset';
    }
    if (d.type === 'dot') {
      const elDot = document.createElement('div');
      elDot.className = 'label-dot';
      if (d.dotColor) elDot.style.background = d.dotColor;
      if (d.pulse) elDot.classList.add('label-dot--pulse');
      if (d.pulseDelay) elDot.classList.add('label-dot--pulse'+d.pulseDelay);
      elContent.appendChild(elDot);
      // const o = d.orientation || 'top';
      el.classList.add('label--' + o);
    }
    if (d.type === 'square') {
      const elSquare = document.createElement('div');
      elSquare.className = 'label-square';
      if (d.squareColor) elSquare.style.background = d.squareColor;
      if (d.pulse) elSquare.classList.add('label-square--pulse');
      // if (d.pulseDelay) elSquare.classList.add('label-square--pulse'+d.pulseDelay);
      elContent.appendChild(elSquare);
      // const o = d.orientation || 'top';
      el.classList.add('label--' + o);
    }
    if (d.type === 'triangle') {
      const elTriangle = document.createElement('div');
      elTriangle.className = 'label-triangle';
      if (d.triangleColor) elTriangle.style.background = d.triangleColor;
      elContent.appendChild(elTriangle);
      const o = d.orientation || 'top';
      el.classList.add('label--' + o);
    }
    d.elem = el;
    d.elemContent = elContent;
    d.elemText = elText;
    d.marker = new mapboxgl.Marker(el, {anchor: d.type === 'line' ? a : (d.anchor ? d.anchor : 'center')}).setLngLat([d.lon, d.lat]);


    d.marker._updateOrig = d.marker._update;
    d.marker._update = () => d.marker._updateOrig(false);
    //

    d.marker._clearFadeTimer();
    d.marker._fadeTimer = 999;
    d.marker._evaluateOpacity = () => {};

    d.shown = false;
  });
}

function loadAllFocusboxes(section) {
  section.focusboxes.forEach((d) => {

    const f = Math.pow(2, zoom - 2);
    const w = d.width * f;
    const h = d.height * f;
    const s = Math.min(w, h) * 0.3;

    const el = document.createElement('div');
    el.className = 'focusbox';
    el.innerHTML = `
      <div class="focusbox-box" style="width: ${w}px; height: ${h}px; transform: translate(-50%, -50%) rotate(${d.rotate}deg);">
        <div class="focusbox-corner focusbox-corner-tl" style="width: ${s}px; height: ${s}px"></div>
        <div class="focusbox-corner focusbox-corner-tr" style="width: ${s}px; height: ${s}px"></div>
        <div class="focusbox-corner focusbox-corner-br" style="width: ${s}px; height: ${s}px"></div>
        <div class="focusbox-corner focusbox-corner-bl" style="width: ${s}px; height: ${s}px"></div>
      </div>
      <div class="focusbox-label" style="top: ${d.labelTop * f}px; left: ${d.labelLeft *f}px"></div>
    `;
    d.elem = el
    d.elemText = el.querySelector('.focusbox-label')
    d.marker = new mapboxgl.Marker(el, {anchor: 'center'}).setLngLat([d.lon, d.lat]);
    d.shown = false;
  });
}


function initMap() {
  
  const dpi = window.devicePixelRatio;
  window.devicePixelRatio = Math.min(dpi, 2);

  mapboxgl.workerCount = 4;
  mapboxgl.maxParallelImageRequests = 32;

  map = new mapboxgl.Map({
    container: mapContainer,
    style: `${PATH}data/style.json`,
    bounds: config.bounds,
    bearingSnap: 0,
    maxTileCacheSize: 3000,
    minTileCacheSize: 300,
    interactive: DEBUG,
    antialias: false,
    attributionControl: false,
  });

  map.addControl(new mapboxgl.AttributionControl({
    compact: false,
  }));

  if (DEBUG) window.map = map;

  updateSize();

  mapLoaded = new Promise((resolve) => {
    map.once('styledata', () => {
      map.once('render', () => {
        document.querySelector('.mapboxgl-ctrl-bottom-right').innerHTML = `<div class="mapboxgl-ctrl mapboxgl-ctrl-attrib"><div class="mapboxgl-ctrl-attrib-inner" role="list"><a href="https://s2maps.eu" target="_blank">EOX</a> | <a href="https://www.mapbox.com/about/maps/" target="_blank" title="Mapbox" aria-label="Mapbox" role="listitem">© Mapbox</a> <a class="mapbox-improve-map" href="https://apps.mapbox.com/feedback/?access_token=${getToken()}" target="_blank" aria-label="Map feedback" role="listitem" rel="noopener nofollow">Improve this map</a></div></div>`;
  
        window.devicePixelRatio = dpi;
        zoom = map.getZoom(); // get initial zoom
        terrain = map.getTerrain();
        exaggeration = terrain.exaggeration;
        resolve();
        

        map._forceMarkerUpdate = () => {};
        
        if (window.devicePixelRatio >= 2) {
          map.projectOrig = map.project;
          map.project = function (a) {
            const x = map.projectOrig(a);
            x.round = function () { return this; };
            return x;
          }
        }

        map.addSource('empty', {
          type: 'geojson',
          data: nothing,
        });
        ['geo', 'images', 'videos', 'geo-top'].forEach((i) => {
          map.addLayer({
            id: 'layer-' + i,
            type: 'fill',
            source: 'empty',
            layout: {
              visibility: 'none'
            },
          });
        });
      });
    });
  });
}

let c;
let e;
let v;
let phase;
let vis;
let o;
let t;
let f;
let d;
let shownNew;
let j;

function update(section, pos, realPos, current) {
  currentZoom = map.getZoom();

  // camera
  if ((!forceUpdate || initial) && section.camera && (current || initial)) {

    c = {
      center: [
        section.cameraScales[orientation].lon(pos),
        section.cameraScales[orientation].lat(pos),
      ],
      zoom: zoom + section.cameraScales[orientation].z(pos),
      pitch: section.cameraScales[orientation].pitch(pos),
      bearing: section.cameraScales[orientation].bearing(pos),
      duration: 0,
      padding: { bottom: 0, left: 0},
    };
    c.padding[padding] = section.cameraScales[orientation].pad(pos) * pad;
    // map.flyTo(c);
    //
    requestAnimationFrame(() => {
      map.jumpTo(c);
    });

    //setTimeout(() => {
    //  map.jumpTo(c);
    //});
    e = section.cameraScales[orientation].terrain(pos) * exaggeration;
    if (e !== currentExaggeration) {
      currentExaggeration = e;
      terrain.exaggeration = e;
      map.setTerrain(terrain);
    }
  }

  // geo
  if (section.geodata) {
    for (j = 0; j < section.geodata.length; j++) {
      d = section.geodata[j];
      if (!d.loaded) continue;
      v = d.scale[orientation](pos);
      phase = v === 0.5 ? 1 : v < 0.5 ? 0 : 2;
      if (v !== d.v || phase !== d.phase) {
        d.phase = phase;
        d.v = v;
        if (phase <= 1) {
          if (d.line) animationFunctions[d.animLineIn](d, 'line', 2*v);
          if (d.area) animationFunctions[d.animAreaIn](d, 'area', 2*v);
          if (d.bubbles) animationFunctions[d.animBubbleIn](d, 'bubble', 2*v);
          if (d.dots) animationFunctions[d.animDotIn](d, 'dot', 2*v);
        } 
        if (phase >= 1) {
          if (d.line) animationFunctions[d.animLineOut](d, 'line', 2-2*v);
          if (d.area) animationFunctions[d.animAreaOut](d, 'area', 2-2*v);
          if (d.bubbles) animationFunctions[d.animBubbleOut](d, 'bubble', 2-2*v);
          if (d.dots) animationFunctions[d.animDotOut](d, 'dot', 2-2*v);
        }

        vis = v > 0 && v < 1;
        if (d._visible === true && !vis) {
          d._visible = false;
          if (d.line) map.setLayoutProperty(d.idLine, 'visibility', 'none');
          if (d.area) map.setLayoutProperty(d.idArea, 'visibility', 'none');
          if (d.dots) map.setLayoutProperty(d.idDots, 'visibility', 'none');
          if (d.bubbles) d.bubbleMarkers.forEach((m) => { m.remove(); });
        } else if (d._visible === false && vis) {
          d._visible = true;
          if (d.line) map.setLayoutProperty(d.idLine, 'visibility', 'visible');
          if (d.area) map.setLayoutProperty(d.idArea, 'visibility', 'visible');
          if (d.dots) map.setLayoutProperty(d.idDots, 'visibility', 'visible');
          if (d.bubbles) d.bubbleMarkers.forEach((m) => { m.addTo(map); });
        }
      }
    }
  }

  // images
  if (section.images) {
    for (j = 0; j < section.images.length; j++) {
      d = section.images[j];
      o = d.scale[orientation](pos);
      if (o !== d.o) {
        d.o = o;
        map.setPaintProperty(d.id, 'raster-opacity', o)
        
        vis = o > 0;
        if (d._visible === true && !vis) {
          d._visible = false;
          map.setLayoutProperty(d.id, 'visibility', 'none');
        } else if (d._visible === false && vis) {
          d._visible = true;
          map.setLayoutProperty(d.id, 'visibility', 'visible');
        }
      }
    }
  };

  // videos
  if (section.videos) {
    for (j = 0; j < section.videos.length; j++) {
      d = section.videos[j];
      if (!d.video || !d.video.duration) continue;
      o = d.scaleOpacity[orientation](pos);
      t = d.scaleSeek[orientation](pos);
      if (o !== d.o) {
        d.o = o;
        map.setPaintProperty(d.id, 'raster-opacity', d.o);
      }
      if (t !== d.t) {
        if (t < d.t) d.video.currentTime = t * d.video.duration;
        d.t = t;
        d.paused = d.video.currentTime >  d.t * d.video.duration;

        vis = o > 0;
        if (d._visible === true && !vis) {
          d._visible = false;
          map.setLayoutProperty(d.id, 'visibility', 'none');
        } else if (d._visible === false && vis) {
          d._visible = true;
          map.setLayoutProperty(d.id, 'visibility', 'visible');
        }
      }
    }
  }

  // labels
  // NOTE: we keep number of html elements limited by adding and removing
  if (section.labels) {
    for (j = 0; j < section.labels.length; j++) {
      d = section.labels[j];
      if (!d.marker) continue;
      shownNew = pos >= d[`timing${orientationStr}`][0] && pos < d[`timing${orientationStr}`][1];
      if (shownNew !== d.shown) {
        d.shown = shownNew;
        if (d.shown) {
          d.marker.addTo(map);
          typeMarkerStart(d);
        } else {
          typeMarkerStop(d);
          d.marker.remove();
        }
      }
      if (d.shown) {
        /*
        if (d.minZoom) {
          d.elem.style.display = currentZoom >= d.minZoom ? 'block' : 'none';
        }
        */
        if (d.minZ) {
          d.elemContent.style.display = currentZoom - zoom >= d.minZ ? 'block' : 'none';
        }
      }
    }
  }

  // focusboxes
  // NOTE: we keep number of html elements limited by adding and removing
  if (section.focusboxes) {
    for (j = 0; j < section.focusboxes.length; j++) {
      d = section.focusboxes[j];
      if (!d.marker) continue;
      shownNew = pos >= d[`timing${orientationStr}`][0] && pos < d[`timing${orientationStr}`][1];
      if (shownNew !== d.shown) {
        d.shown = shownNew;
        if (d.shown) {
          d.marker.addTo(map);
          typeMarkerStart(d);
        } else {
          typeMarkerStop(d);
          d.marker.remove();
        }
      }
    }
  }

  // fading for text sections XXX
  //if (!forceUpdate && realPos != 0 && realPos != section[`length${orientationStr}`] && section.scaleFade[orientatin]) {
  if (section.scaleFade[orientation] && current) {
    f = section.scaleFade[orientation](realPos);
    if (f !== section.f) {
      mapOverlay.style.opacity = f;
      section.f = f;
    }
  }

  if (DEBUG) {
    currentPos = pos;
  }
  if (initial) initial = false;
}

function getCameraParameters() {
  const c = map.getCenter();
  const b = map.getBearing();
  const p = map.getPitch();
  const zzoom = map.getZoom();
  const zz = zzoom - zoom;
  return {
    lon: c.lng,
    lat: c.lat,
    pitch: p,
    bearing: b,
    z: zz,
    zoom: zzoom
  };
}

const loopFunctions = [];
let pageYOffset;

function makeLoop(section) {
  let p;
  let pos = 0;
  let targetPos = 0;
  let current = false;

  loopFunctions.push(function() {
    //targetPos = Math.min(section[`length${orientationStr}`], Math.max(0, (-section.elem.getBoundingClientRect().top + config.screen/2) / config.screen));
    // const p = (window.pageYOffset - section.top + config.screen/2) / config.screen;
    p = (pageYOffset - section.top) / config.screen;
    targetPos = Math.min(section[`length${orientationStr}`], Math.max(0, p));
    current = p >= 0 && p <= section[`length${orientationStr}`];

    if (pos !== targetPos || forceUpdate) {
      if (Math.abs(pos - targetPos) < config.scrollDelta) {
        pos = targetPos;
      } else if (pos > targetPos) {
        pos -= config.scrollDelta;
      } else if (pos < targetPos) {
        pos += config.scrollDelta;
      }
      update(section, pos, targetPos, current);
    }

    if (section.videos) section.videos.forEach((d) => {
      if (d.checkvid) d.checkvid();
    });
  });


}

function startLoop(content) {
  //window.addEventListener('scroll', () => {
  //  pageYOffset = window.pageYOffset;
  //});

  let i;
  const loop = function () {
    requestAnimationFrame(loop);
    pageYOffset = window.pageYOffset;

    if (pageYOffset < window.innerHeight * 0.8) {
      if (mapRunning) stopMap();
    } else {
      if (!mapRunning) startMap();
    }

    for (i = 0; i < loopFunctions.length; i++) {
      loopFunctions[i]();
    }
    if (window.extraLoopFunctions) {
      for (i = 0; i < window.extraLoopFunctions.length; i++) {
        window.extraLoopFunctions[i]();
      }
    }
    forceUpdate = false;
    if (DEBUG) debugAll();
  }

  requestAnimationFrame(loop);
}

function initSection(section) {
  // load images
  if (section.images) loadAllImages(section);
  // load videos
  if (section.videos) loadAllVideos(section);
  // load geodata
  if (section.geodata) loadAllGeodata(section);
  // load labels
  if (section.labels) loadAllLabels(section);
  // load focusboxes
  if (section.focusboxes) loadAllFocusboxes(section);

  // prepare camera
  if (section.camera) {
    section.cameraScales = {};

    function getScale(prop, cameraList) {
      return scaleLinear()
        .domain(cameraList.filter(x => x[prop] !== undefined).map(x => x.scroll))
        .range(cameraList.filter(x => x[prop] !== undefined).map(x => x[prop]))
        .clamp(true)
    }

    section.cameraScales['portrait'] = {};
    section.cameraScales['landscape'] = {};
    cameraProps.forEach((p) => {
      section.cameraScales['portrait'][p] = getScale(p, section.camera.portrait);
      section.cameraScales['landscape'][p] = getScale(p, section.camera.landscape);
    });
  }

  preloadTiles(section);
  //if (!tilesLoading) reallyPreloadTiles(); // TODO: erstmal deaktiviert, muss besser gemacht werden

  // start loop
  makeLoop(section);
}


function updatePositions(content) {
  content.forEach((s) => {
    //if (s.type !== 'scroll') return;
    if (!s.elem) return;
    s.top = s.elem.offsetTop;
    s.bottom = s.top + s.elem.offsetHeight;
  });
}

function resize(content) {
  config._fadeDurationIn = config.fadeDurationIn * window.innerHeight / config.screen;
  config._fadeDurationOut = config.fadeDurationOut * window.innerHeight / config.screen;
  config._fadeOffsetIn = config.fadeOffsetIn; // * window.innerHeight / config.screen;
  config._fadeOffsetOut = config.fadeOffsetOut; // * window.innerHeight / config.screen;

  content.filter(x => x.type === 'scroll').forEach((section) => {
    section.scaleFade = {};
    ['landscape', 'portrait'].forEach(o => {
      const oStr = getStr(o)
      section.scaleFade[o] = scaleLinear()
        .domain([
          config._fadeOffsetIn,
          config._fadeOffsetIn + config._fadeDurationIn,
          section[`length${oStr}`] - config._fadeOffsetOut - config._fadeDurationOut,
          section[`length${oStr}`] - config._fadeOffsetOut,
        ])
        .range([
          section.fadein ? 1 : 0,
          0, 
          0,
          section.fadeout ? 1 : 0,
        ])
        .clamp(true);
    })
    section.f = null;
  });
}

function getToken() {
  // console.log(window.location.hostname);
  if (window.location.hostname === "interaktiv-staging.tagesspiegel.de") return "pk.eyJ1IjoiZC1tLSIsImEiOiJjbDNtcnE5MHgwNmY2M2RzOWFrZG81Z2VqIn0.__WDkVPzJb_HOU7H573lwg"; // localhost, interaktiv-staging, account david
  if (window.location.hostname === "localhost") return "pk.eyJ1IjoiZC1tLSIsImEiOiJjbDNtcnE5MHgwNmY2M2RzOWFrZG81Z2VqIn0.__WDkVPzJb_HOU7H573lwg"; // localhost, interaktiv-staging, account david
  return "pk.eyJ1IjoidHNwaW5ub2xhYiIsImEiOiJjbDNtczExb2owN3NvM2psZWRhNnRhNHM1In0.hS3gFagRUaY3aQGg5UWFqg"; // interaktiv, intas, account digital@tagesspiegel.de
  // 'pk.eyJ1IjoiZmZrdHZzcHIiLCJhIjoiY2wyZjBqbzNkMDN4NTNicWdlZzJkaWlmZCJ9.BGOrI-Ou8_vu-jzGLkZ7ZA'; // eric
}


let srcNeedsMetrics = {};
let srcNeedsExtraLines = {};

export function start(mapContainerE, mapOverlayE, content, debug, cbk) {
  callback = cbk;

  DEBUG = debug && typeof(window) !== 'undefined' && document.querySelector('.debug');
  mapboxgl = window.mapboxgl;
  mapboxgl.accessToken = getToken();

  mapContainer = mapContainerE;
  mapOverlay = mapOverlayE;

  setupResize();
  updatePadding();
  initMap();

  updatePositions(content);
  resize(content);
  setTimeout(() => {
    updatePositions(content);
    resize(content);
  }, 2000);
  window.addEventListener('resize', () => {
    updatePositions(content);
    resize(content);
    updatePadding();
  });


  mapLoaded.then(() => {
    const scrollsections = content.filter(x => x.type === 'scroll');
    const fullscreensections = content.filter(x => x.type === 'fullscreen');

    scrollsections.forEach((s) => {
      if (s.geodata) {
        s.geodata.forEach((d) => {
          if (srcNeedsMetrics[d.src] === undefined) srcNeedsMetrics[d.src] = false;
          if (srcNeedsExtraLines[d.src] === undefined) srcNeedsExtraLines[d.src] = false;

          if (d.animLineOut === 'draw' || d.animLineIn === 'draw') srcNeedsMetrics[d.src] = true;
          if (d.line && d.area && srcNeedsMetrics[d.src]) srcNeedsExtraLines[d.src] = true;
        });
      }
    });


    scrollsections.forEach(initSection);


    fullscreensections.forEach((s) => {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio > 0) {
          const r = entries[0].target.getBoundingClientRect();
          if (r.top < window.innerHeight / 2 && r.bottom > window.innerHeight ) {
            mapOverlay.classList.add('fullscreen');
          } else {
            mapOverlay.classList.remove('fullscreen');
          }
        }
      }, { threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.4, 0.5, 0.6, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1] });
      // });
      observer.observe(s.elem);
    });


    startLoop(content);
  });
}


function debug(key, value) {
  const debug = document.querySelector('.debug');
  const valueProcessed = parseFloat(value).toFixed(key==='lat' || key==='lon'? 4:2);
  const elem = debug.querySelector('ul li.' + key + ' span');
  debug.style.display = 'flex';
  if (!elem) {
    const li = document.createElement('li');
    li.classList.add(key);
    li.innerHTML = key + ': <span>' + valueProcessed + '</span>';
    debug.querySelector('ul').appendChild(li);
  } else {
    elem.innerHTML = valueProcessed;
  }
}

function debugAll() {
    const ps = getCameraParameters();
    debug('pos', currentPos);
    debug('lat', ps.lat);
    debug('lon', ps.lon);
    debug('z', ps.z);
    debug('zoom', ps.zoom);
    debug('pitch', ps.pitch);
    debug('bearing', ps.bearing);
}


function typeMarkerStart(d) {
  let i = 0;

  function type() {
    if (i < d.text.length) {
      d.elemText.innerHTML += d.text.charAt(i);
      i++;
      d._timeout = setTimeout(type, 50);
    }
  }

  // if (d.typing || d.type == 'line')
  if (d.typing)
    d._timeout = setTimeout(type, 200); // delay to account for line animation
  else
    d.elemText.innerHTML = d.text;
}

function typeMarkerStop(d) {
  d.elemText.innerHTML = '';
  if (d._timeout) clearTimeout(d._timeout);
}
